import React, { useState, useEffect } from "react";
import { Dialog } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

const ConfirmationDialog = ({
  open,
  onConfirm,
  onCancel,
  title,
  content,
  confirmButton,
  cancelButton,
}) => {
  const { t } = useTranslation();
  const translation = t("trustedNetwork").confirmationDialog;
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size for responsive behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const defaultConfirmButton = {
    content: translation?.yes || "Yes",
    primary: true,
  };
  const defaultCancelButton = translation?.cancel || "Cancel";

  // Responsive dialog styles
  const dialogStyle = {
    minWidth: isMobile ? "90vw" : "400px",
    maxWidth: isMobile ? "95vw" : "500px",
    width: isMobile ? "90vw" : "auto",
    maxHeight: isMobile ? "90vh" : "80vh",
    margin: isMobile ? "10px" : "auto",
  };

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      header={title}
      content={content}
      confirmButton={confirmButton || defaultConfirmButton}
      cancelButton={cancelButton || defaultCancelButton}
      style={dialogStyle}
    />
  );
};

export default ConfirmationDialog;
